import { useUiStore } from '@/state/uiStore';
import { useConfigStore } from '@/state/configStore';

export function StoryPeel() {
  const peel = useUiStore((s) => s.storyPeel);
  const setPeel = useUiStore((s) => s.setStoryPeel);
  const storyCount = useConfigStore((s) => s.config?.stories.length ?? 0);

  // Peel layers, top-down:
  //   0          : nothing hidden
  //   1          : roof hidden (peek into the top story)
  //   2..N+1     : also hide k = peel-1 top stories
  //   N+2        : also hide the lot base plate (reveals a basement, if any)
  //
  // The "+ ground" step is always available even without a basement —
  // hiding the base plate just looks like the house is hovering, which is
  // consistent with the rest of the slider.
  const maxPeel = Math.max(1, storyCount + 2);

  // Single-line labels so the caption box never wraps to a second line
  // (which would push the whole bottom-anchored panel upwards on every
  // slider tick — user-reported jitter).
  const label = (() => {
    if (peel === 0) return 'off';
    if (peel === 1) return 'roof';
    if (peel >= storyCount + 2) return 'all + ground';
    const stories = peel - 1;
    return `roof + ${stories}`;
  })();

  return (
    <div className="peel panel">
      <div className="label">Peel</div>
      <input
        type="range"
        min={0}
        max={maxPeel}
        step={1}
        value={Math.min(peel, maxPeel)}
        onChange={(e) => setPeel(Number(e.target.value))}
        aria-label="Peel level"
        aria-valuetext={label}
      />
      <div className="label peel-caption">{label}</div>
    </div>
  );
}
